export default __webpack_public_path__ + "static/media/chiclayo-street_yellow_taxi.bab60034.jpg";